import { EventTypes } from '@bg-shared/integrations/shared/EventTypes';
import { IPostMessageApi } from './createPostMessenger';
import { themeEditor } from '../themeEditor';

export const setupPMContracts = (pm: IPostMessageApi, iFrame: HTMLIFrameElement): void => {
    pm.subscribe<{ height: string }>(EventTypes.NEW_RESIZE, (message) => {
        iFrame.style.height = `${message.payload.height}px`;
    });

    pm.subscribe<{ scrollTo: string }>(EventTypes.SCROLL_TO, (message) => {
        window.scroll(0, Number(message.payload.scrollTo));
    });

    const sendWindowData = (): void => {
        pm.emit({
            type: EventTypes.WINDOW_DATA,
            payload: {
                width: window.innerWidth,
                height: window.innerHeight,
                scrollX: window.scrollX,
                scrollY: window.scrollY,
                clientRect: iFrame.getBoundingClientRect(),
                clientTop: iFrame.clientTop,
                clientLeft: iFrame.clientLeft,
            },
        });
    };

    pm.subscribe(EventTypes.WINDOW_DATA, () => {
        sendWindowData();
    });

    pm.subscribe(EventTypes.SUBSCRIBE_WINDOW_RESIZE, () => {
        window.addEventListener('resize', sendWindowData);

        sendWindowData();
    });

    pm.subscribe(EventTypes.UNSUBSCRIBE_WINDOW_RESIZE, () => {
        window.removeEventListener('resize', sendWindowData);
    });

    pm.subscribe(EventTypes.THEME_READY, () => {
        themeEditor.setReady();
    });
};
